import React from 'react';

import { Box, Button, Container, Typography } from 'components';
import { Danger } from 'iconsax-react';

import { useNavigate } from 'third-party';

import { palette } from 'styles/theme';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 3,
        }}
      >
        <Danger variant="TwoTone" size="100" color={palette.primary900} />

        <Typography variant="h1" color="text.secondary" gutterBottom>
          Oops! Page Not Found
        </Typography>

        <Typography color="text.secondary">
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
          sx={{ mt: 2 }}
        >
          Back to Home
        </Button>
      </Box>
    </Container>
  );
};
